module.exports = __webpack_public_path__ + "static/media/meme_11.fbea1c70.jpg";